// Components/Auth/Login.js
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthAPI from "../../services/API/authServices"; // ✅ use the axios service
import "./auth.css";
import { useNotification } from "../../context/NotificationContext";

export default function Login() {
  const { showNotification } = useNotification();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigateTo = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // ✅ Call backend login
      const { token, user } = await AuthAPI.login(email, password);

      // Store token + user in localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      showNotification(
        `✅ ${
          user?.name ? user.name.toUpperCase() : "Login successfully"
        } Login`,
        "success"
      );

      navigateTo("/dashboard"); // dashboard
    } catch (err) {
      console.error("Login error", err);
      showNotification(
        err.response?.data?.msg || "Invalid credentials",
        "error"
      );
    }
  };

  return (
    <div className="auth-container">
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Login</button>
      </form>
      <p>
        Don’t have an account? <Link to="/register">Register</Link>
      </p>
    </div>
  );
}
